var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyPopper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "45px",
    viewBox: "0 0 46 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8462C9FE-1019-43DA-930B-48681E857C87@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6.-Talent-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-Talent-Management/Creation-successful",
    transform: "translate(-697.000000, -221.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(445.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "party-popper",
    transform: "translate(252.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.648,31.979 L14.021,9.352 C13.7760628,9.10680126 13.4216295,9.0059102 13.0842801,9.08535843 C12.7469307,9.16480666 12.4747716,9.41326478 12.365,9.742 L1.052,43.684 C0.950479438,43.9888053 1.00158449,44.3238255 1.18936511,44.5844999 C1.37714573,44.8451743 1.67873278,45 2,45 C2.10746178,45 2.21419984,44.9824203 2.316,44.948 L36.258,33.635 C36.5867352,33.5252284 36.8351933,33.2530693 36.9146416,32.9157199 C36.9940898,32.5783705 36.8931987,32.2239372 36.648,31.979 Z",
    id: "Path",
    fill: "#EFD358"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E2AC4B",
    transform: "translate(24.627125, 21.373075) rotate(-45.000000) translate(-24.627125, -21.373075) ",
    cx: 24.6271255,
    cy: 21.3730745,
    rx: 5,
    ry: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,24.0000031 C29.6584545,23.9983886 29.3413534,23.8225702 29.15906,23.5337364 C28.9767665,23.2449025 28.9544962,22.8830058 29.1,22.574 C31.616,17.225 37.905,15.374 44.39,18.074 C44.8997588,18.2866296 45.1406296,18.8722412 44.928,19.382 C44.7153704,19.8917588 44.1297588,20.1326296 43.62,19.92 C38.169,17.65 32.946,19.092 30.91,23.42 C30.7459609,23.7744542 30.390571,24.0009665 30,24.0000031 Z",
    id: "Path",
    fill: "#43A6DD"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E86C60",
    cx: 36,
    cy: 8,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E2AC4B",
    cx: 40,
    cy: 38,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5A7A84",
    cx: 27,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#AE453E",
    cx: 41.5,
    cy: 25.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E2AC4B",
    cx: 16.5,
    cy: 3.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,18.000002 C19.5695696,18.000002 19.1874307,17.7245699 19.0513167,17.3162278 C18.9152027,16.9078856 19.0556557,16.4582582 19.4,16.2 C24.0012277,12.774257 25.5423098,6.57559877 23.081,1.394 C22.8727484,0.88848695 23.1090796,0.309434715 23.6115742,0.094001771 C24.1140688,-0.121431173 24.6964295,0.106625844 24.919,0.606 C27.7640305,6.63392181 25.9559062,13.8320901 20.6,17.8 C20.4271088,17.9302129 20.2164407,18.0004356 20,18.000002 Z",
    id: "Path",
    fill: "#E86C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.172,12.828 C2.90680519,12.828 2.65249273,12.7225494 2.465,12.535 C1.16521708,11.2796276 0.643937014,9.42061054 1.10151422,7.67246338 C1.55909142,5.92431622 2.92431622,4.55909142 4.67246338,4.10151422 C6.42061054,3.64393701 8.27962765,4.16521708 9.535,5.465 C9.91397221,5.85737889 9.90855237,6.48108478 9.52281858,6.86681858 C9.13708478,7.25255237 8.51337889,7.25797221 8.121,6.879 C6.93394279,5.74604438 5.06605721,5.74604438 3.879,6.879 C2.70785419,8.05049955 2.70785419,9.94950045 3.879,11.121 C4.16490792,11.4069943 4.25042191,11.8370366 4.09567798,12.2106546 C3.94093405,12.5842725 3.5763959,12.828 3.172,12.828 L3.172,12.828 Z",
    id: "Path",
    fill: "#43A6DD"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopper);
export default __webpack_public_path__ + "static/media/PartyPopper.e5dfa1d6f67e97359bb3f9da1589792d.svg";
export { ForwardRef as ReactComponent };